<template lang="pug">
  #TrialPlan
    .activity-page.text-center
      .banner-area
        img(
          src='@/assets/images/trial-plan/reserve_banner.png?v=1'
        )
      .activity-area
        img(
          src='@/assets/images/trial-plan/reserve_rule.png?v=1'
        )
        .form-area
          .form-item
            label(
              for='name'
            ) 姓名
            .form-input
              input(
                type='text' 
                name='name' 
                v-model='user.name'
              )
          .form-item
            label(
              for='phone'
            ) 手機
            .form-input
              input(
                type='text' 
                name='phone' 
                v-model='user.phone'
              )
          .form-item
            label(
              for='phone'
            ) 收件地址
            .form-input
              UdSelectTwzip.mb-1(
                v-model="city"
                flex
              )
              input(
                type='text' 
                name='address' 
                v-model='input_address'
                placeholder='請輸入地址'
              )
        .check-area
          .form-check
            input#agree(
              type='checkbox' 
              name='agree' 
              v-model='agree'
            )
            label.agree(
              for='agree'
            ) 同意個資使用 &
             |
             a(href="https://www.shuuemura.com.tw/pages/privacy")  隱私權計畫

        .button-area
          button(
            :disabled='!isCanClick'
            @click='submitHandler'
          )
            img(
              src='@/assets/images/trial-plan/button_join.png'
            )
      .info-area
        img(
          src='@/assets/images/trial-plan/info.png?v=2'
        )

</template>

<script>
import { mapState } from "vuex";
import { M_MY_SA_INDEX } from "@/router/member/my-sa";
import { M_PLAN_ACTIVITY } from "@/router/member/trial-plan";
import UdSelectTwzip from "@/components/udon-ui/UdSelectTwzip.vue";

export default {
  name: "TrialPlanSignUp",
  components: {
    UdSelectTwzip,
  },
  data() {
    return {
      isCanClick: 0,
      user: {
        year: "2024",
        name: "",
        phone: "",
        address: "",
      },
      city: ["", ""],
      input_address: "",
      agree: false,
    };
  },
  // mounted() {
  //   const vm = this;
  //   vm.$store.commit('toggleLoading', false);
  // },
  created() {
    const vm = this;
    vm.$store.commit("toggleLoading", false);
    vm.$swal.fire({
      title: "載入中，請稍候",
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
    // 取得個人資料
    vm.$store.dispatch("member_trial_plan/getSubscriptionStatusHandler").then(() => {
      vm.$swal.close();
      vm.$store.commit("toggleLoading", false);
      const { isBindBa } = vm.customerStatus;
      isBindBa
        ? vm.statusHandler()
        : vm.$router.push({ name: M_MY_SA_INDEX, params: { action: "trial_plan" } }); //action -> 用來判斷從bc綁定會員卡成功之後回到的頁面，
    });
  },
  methods: {
    statusHandler() {
      const { status } = this.customerStatus;
      switch (status) {
        case 0: //:訂閱資格審核中
          this.$swal.fire({
            title: "您的訂閱資料審核中",
            html: '<p class="mb-0">請耐心等待結果</p>',
            showCancelButton: false,
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "custom-swal-btn",
            },
          });
          break;
        case 1: //已經訂閱成功
          this.$router.push({
            name: M_PLAN_ACTIVITY,
          });
          break;
        case 2: //未符合訂閱資格
        case 3: //訂閱資格審核失敗
        case 99: //未訂閱
          this.isCanClick = 1;
          break;
        default:
          break;
      }
    },
    submitHandler() {
      const { name, phone } = this.user;
      if (!this.agree) {
        this.alertHandler("請先同意隱私權政策");
        return;
      }
      if (!name || !phone || !this.input_address) {
        this.alertHandler("欄位為必填項目");
        return;
      }
      if (!this.city[0] || !this.city[1]) {
        this.alertHandler("縣市區域為必選");
        return;
      }
      //回填地址
      const optionArr = this.$children[0].options;
      if (!optionArr) return;
      const cityTemp = optionArr.find((item) => item.value === this.city[0]);
      const countryTemp = cityTemp.children.find((item) => item.value === this.city[1]);
      this.user.address = cityTemp.label + countryTemp.label + this.input_address;
      this.submit();
    },
    alertHandler(text) {
      this.$swal.fire({
        icon: "error",
        title: text,
      });
    },
    async submit() {
      const vm = this;
      if (!vm.isCanClick) return;
      vm.$swal.fire({
        title: "送出中，請稍候",
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        },
      });
      vm.$store
        .dispatch("member_trial_plan/updateSubscriptionHandler", vm.user)
        .then(() => {
          vm.isCanClick = 0;
          vm.$store.commit("toggleLoading", false);
          vm.$swal
            .fire({
              title: "已成功送出",
              showCancelButton: false,
              confirmButtonText: "確定",
              customClass: {
                confirmButton: "custom-swal-btn",
              },
            })
            .then(() => {
              vm.$swal.close();
              vm.backToLINEHandler();
            });
        })
        .catch((err) => {
          vm.isCanClick = 0;
          vm.$store.commit("toggleLoading", false);
          this.$swal.fire({
            title: err.message,
            showCancelButton: false,
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "custom-swal-btn",
            },
          });
        });
    },
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
  },
  computed: {
    ...mapState({
      customerStatus: (state) => state.member_trial_plan.customerStatus,
    }),
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
  height: auto;
  vertical-align: center;
  border-style: none;
}

button {
  border-radius: 0;
  text-transform: none;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
  &:hover {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
  }
  &:focus {
    outline: none;
    outline: none;
  }
}
select {
  &:focus {
    outline: none;
    outline: none;
  }
}
/*------ activity-page ------*/
.text-center {
  max-width: 540px;
  margin: 0 auto;
  min-height: 100%;
  text-align: center;
  padding: 0;
  // overflow-y: scroll;
  // overflow-x: hidden;
  // -ms-overflow-style: none;
  // scrollbar-width: none;
  // &::-webkit-scrollbar {
  // 	display: none;
  // }
}
.activity-area {
  color: #fff;
  max-width: 100%;
  background: url(../../../assets/images/trial-plan/bg_form.png) top center repeat;
  background-size: 100%;
}
.activity-page {
  .form-area {
    padding-top: 6%;
    .form-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: start;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 15% 0 10%;
      margin-bottom: 4%;
      label {
        flex: 0 0 28%;
        padding-right: 5%;
        text-align-last: justify;
        text-align: justify;
        text-justify: distribute-all-lines;
        margin-bottom: 0;
      }
      .form-input {
        flex: 0 0 72%;
        input {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          border-radius: 0px;
          border: 1px solid #ccc;
          font-size: 14px;
          width: 100%;
          min-height: 40px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          background-color: #fff !important;
          -webkit-transition: all 0.2s ease;
          -o-transition: all 0.2s ease;
          transition: all 0.2s ease;
          outline: none !important;
          -webkit-box-shadow: none;
          box-shadow: none;
          padding: 0 6%;
        }
      }
      .form-select {
        position: relative;
        flex: 0 0 70%;
      }
      ::v-deep .ud-select select {
        border: 1px solid #ccc;
        outline: unset;
        min-height: 40px;
        text-indent: 1px;
        color: #333;
        font-size: 14px;
        width: 100%;
        margin: 0;
        transition: border 0.2s ease;
        cursor: pointer;
        padding: 0 10%;
        background: #fff;
        border-radius: 0px;
      }
    }
  }
}
.check-area {
  .agree {
    font-size: 12px;
  }
}
.button-area {
  padding-top: 4.5%;
  padding-bottom: 7.5%;
  button {
    width: 46%;
  }
}
@media (min-width: 768px) {
  label {
    font-size: 18px;
  }
  .check-area .agree {
    font-size: 16px;
  }
}
@media (max-width: 320px) {
  label {
    font-size: 12px;
  }
}
/*------ check-box ------*/
a {
  color: #fff;
}
[type="checkbox"] {
  &:checked {
    position: absolute;
    left: -9999px;
    + {
      label {
        position: relative;
        padding-left: 20px;
        cursor: pointer;
        line-height: 14px;
        display: inline-block;
        color: #fff;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 14px;
          height: 14px;
          border: 1px solid #fff;
          background: #fff;
        }
        &:after {
          content: "";
          width: 8px;
          height: 8px;
          background: #000;
          position: absolute;
          top: 3px;
          left: 3px;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
          opacity: 1;
          -webkit-transform: scale(1);
          transform: scale(1);
        }
      }
    }
  }
  &:not(:checked) {
    position: absolute;
    left: -9999px;
    + {
      label {
        position: relative;
        padding-left: 20px;
        cursor: pointer;
        line-height: 14px;
        display: inline-block;
        color: #fff;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 14px;
          height: 14px;
          border: 1px solid #fff;
          background: #fff;
        }
        &:after {
          content: "";
          width: 8px;
          height: 8px;
          background: #000;
          position: absolute;
          top: 3px;
          left: 3px;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
          opacity: 0;
          -webkit-transform: scale(0);
          transform: scale(0);
        }
      }
    }
  }
}
</style>
